export default "__VITE_ASSET__a38c64fb__"